import WhiteButton from '../../components/white-button';
import CountUp from '../../components/countup';
import {useRef, useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {toggleActionModal} from '../../../reducers/modals-action/actions';
import {navigate} from '../../../utils/navigation';
import {closePromotionModal, clickPromotionModal} from '../../../utils/promotions';
import ModalsLib from '../../../lib/modals';
import Selector from '../../../selectors/modals_action/welcome-package/index';


import Main from './main';
import Points from './points';
import Status from './status';

export default ({index}) => {
    const {welcome_bonus} = useSelector(Selector),
          dispatch = useDispatch(),
          [stage, setStage] = useState('main');

    // Refs
    const overlay = useRef(),
          modal = useRef();

    const closeAction = (trigger, callback) => {
        if(modal.current) {
            modal.current.classList.remove('animate__bounceInUp');
            modal.current.classList.add('animate__bounceOutDown');
        }

        if(overlay.current) {
            overlay.current.classList.remove('animate__fadeIn');
            overlay.current.classList.add('animate__fadeOut');
        }

        setTimeout(() => {
            dispatch(toggleActionModal('welcome-package')); 
            
            if(trigger === 'close')
                closePromotionModal('welcome-package');
            else
                clickPromotionModal('welcome-package', callback);
        }, 500);
    }

    useEffect(() => {
        if(welcome_bonus.status === 1)
            setStage('status');

        if(welcome_bonus.status === 2)
            closeAction();
    }, [welcome_bonus]);

    // if(!welcome_bonus)
    //     return <></>;
    
    return (
        <div className="action-modal-fix welcome-package">
            <div style={{zIndex: 400 + index}} className="action-modal-overlay animate__animated animate__fadeIn animate__faster" ref={overlay}></div>
            <div style={{zIndex: 400 + index}} className="action-modal-container">
                <div className="action-modal animate__animated animate__bounceInUp animate__faster" ref={modal}>
                    {stage === 'main' && <Main closeAction={closeAction} welcome_bonus={welcome_bonus} nextStage={e => setStage('points')} />}
                    {stage === 'points' && <Points closeAction={closeAction} welcome_bonus={welcome_bonus} nextStage={e => setStage('status')} />}
                    {stage === 'status' && <Status closeAction={closeAction} welcome_bonus={welcome_bonus} />}
                </div>
            </div> 
        </div>
    )
}